<ng-container *ngIf="isVisible()">
  <div [id]="navLink.id" class="ds-grid container-fluid mb-7">
    <div class="row pt-7 mb-6 justify-content-center">
      <h2
        class="col-7 d-flex justify-content-center ds-heading--l mb-0">{{'productDetails.publisher' | cxTranslate}}</h2>
    </div>
    <div class="row justify-content-center align-content-center">
      <div
        class="col-12 col-sm-10 col-lg-7 d-flex flex-column flex-md-row align-items-md-start align-items-center justify-content-center">
        <div *ngIf="hasLogo" class="mb-4 mb-md-0 me-md-5 p-3 logo d-flex justify-content-center align-items-center">
          <cx-media [alt]="name" [container]="{url: logo}"></cx-media>
        </div>
        <div class="d-flex flex-column">
          <h3 class="text-center text-md-start ds-heading--m mb-1">
            {{name}}
          </h3>
          <div (click)="openPublisherSolutions(name)" (keydown)="openPublisherSolutionsWithKeyboard(name, $event)"
               [attr.data-cy]="'publisher-solutions'"
               class="btn text-center text-md-start btn-link btn-left" rel="noopener noreferrer" tabindex="0">
            {{'productDetails.publisherSolutions' | cxTranslate}}
          </div>
          <div class="ds-body mt-4">
            <dcp-limited-text [charLimit]="300" [text]="description"></dcp-limited-text>
          </div>
          <div class="d-flex align-content-start mt-4">
            <dcp-cta-form [slmTransactionTypes]="slmTransactionTypes" [isPublisherSection]="true"
                          class="flex-grow-0"></dcp-cta-form>
            <a *ngIf="website" [attr.data-cy]="'publisher-website'" class="btn btn-link ps-4" href="{{website}}"
               rel="noopener noreferrer"
               target="_blank">
              {{'productDetails.viewPublisherInformation' | cxTranslate}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
